export default "__VITE_PUBLIC_ASSET__76d820c7__"